const Sale = {
  init() {
    this.events();
  },

  /**
   * Events
   */
  events() {
    $("body").on("click", ".sale-filter:not(.active)", (e) => {
      const btnEl = $(e.currentTarget);
      $(".sale-filter").removeClass("active");
      btnEl.addClass("active");

      this.filterItems();
    });
  },

  /**
   * Filter items
   */
  filterItems() {
    const category = $(".sale-filter.active").data("target");

    // No filtered cat, show all
    if (!category) {
      $(".filter-item").fadeIn();
      return;
    }

    // Filter item by cat
    $(".filter-item").each((_i, item) => {
      item = $(item);

      let cats = item.data("cats");
      cats = cats.split(", ");

      if (cats.includes(category)) {
        item.fadeIn();
      } else {
        item.hide();
      }
    });
  },
};
export default Sale;
